import { pluralRu } from './pluralRu'

/**
 * SNAKE-27 follow-up: pure social-proof copy for TonPreviewScreen.
 *
 *   count < 10        → "Ты в числе первых!" — implies early-adopter scarcity
 *                       and avoids the awkward "Уже ждут: 3 игрока" line that
 *                       undercuts the marketing effect.
 *   count >= 10       → "Уже ждут: 1 234 игрока" — uses Intl.NumberFormat
 *                       with the ru-RU narrow no-break space group separator
 *                       and the correct Russian plural suffix.
 *
 * Lives in its own module so unit tests can import it without DOM/window
 * dependencies (mirrors pluralRu.ts).
 */

const FIRSTS_THRESHOLD = 10

const RU_NUMBER_FORMAT = (() => {
  try {
    return new Intl.NumberFormat('ru-RU')
  } catch {
    return null
  }
})()

export function formatWaitlistCount(count: number): string {
  if (!Number.isFinite(count) || count < 0) return '0'
  const n = Math.floor(count)
  if (RU_NUMBER_FORMAT) return RU_NUMBER_FORMAT.format(n)
  return String(n)
}

export function formatWaitlistCountLine(count: number): string {
  if (!Number.isFinite(count) || count < 0) return ''
  const n = Math.floor(count)
  if (n < FIRSTS_THRESHOLD) return 'Ты в числе первых!'
  const formatted = formatWaitlistCount(n)
  const suffix = pluralRu(n, 'игрок', 'игрока', 'игроков')
  return `Уже ждут: ${formatted} ${suffix}`
}
